// Rails entry point — `react_component 'Invoices/QboTaxPrecheck', { ... }`.
//
// The implementation lives in QboTaxPrecheckModalView.tsx (NOT named after the
// directory): webpack's require.context resolution treats a sibling file named
// after its parent directory as a self-import, yielding an undefined export at
// runtime (see the sibling PaymentLifecycleIcons for the same gotcha).
import React from 'react';
import { QboTaxPrecheckModalView } from './QboTaxPrecheckModalView';
export default function Index(props) {
    return React.createElement(QboTaxPrecheckModalView, Object.assign({}, props));
}
